import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TEMPLATES_QUERY_KEY} from "../queryKeys";

type TranslateTemplateVariables = {
  id: string;
};

const translateTemplate = async ({id}: TranslateTemplateVariables): Promise<void> => {
  await axiosReachInstance.post<void>(`/templates/${id}/translate`);
};

export const useTranslateTemplate = (
  options?: BaseMutationOptions<void, TranslateTemplateVariables>
): BaseUseMutationResult<void, TranslateTemplateVariables> => {
  return useBaseMutation<void, TranslateTemplateVariables>(translateTemplate, {
    ...options,
    prefixKeysToReset: () => [[TEMPLATES_QUERY_KEY]],
  });
};
